<template>
    <div v-show="visible" id="setting-placeholder">
        <div class="close-bar">
            <span @click="close" class="bjy-close">X</span>
        </div>
        <div class="placeholder"></div>
    </div>
</template>
<script>
let eventEmitter = BJY.eventEmitter
export default {
    name: 'SettingDialog',
    data() {
        return {
            visible: false,
            instance: null,
        }
    },
    methods: {
        show() {
            let me = this
            this.visible = true
            if (!this.instance) {
                this.instance = BJY.Setting.create({
                    element: $('#setting-placeholder .placeholder'), //外层容器
                    replace: false,
                    showCloseButton: true,
                    hasCloudReocrd: false,
                    hasCameraTab: true, // 摄像头设置
                    hasMicTab: true, //麦克风设置
                    hasSpeakerTab: true, //扬声器设置
                    hasRecordTab: false, //录制
                    onCloseButtonClick: function () {
                        //处理关闭回调
                        me.visible = false
                    },
                })
            }
        },
        close() {
            this.visible = false
        },
    },
    mounted() {
        let me = this
        eventEmitter.on(eventEmitter.OPEN_SETTING_DIALOG_TRIGGER, function () {
            me.show()
        })
    },
}
</script>
<style lang="scss">
#setting-placeholder {
    position: absolute;
    z-index: 10;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    background: #fff;
    border-radius: 4px;
    .close-bar {
        height: 42px;
        padding: 0 16px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        border-bottom: 1px solid #ccc;
        &::before {
            content: '设置';
        }

        .bjy-close {
            font-size: 18px;
            color: #999;
            margin-right: 0;
            cursor: pointer;
        }
    }

    .bjy-device-settings-navs {
        margin: 20px;
        width: 100px;
        .bjy-item {
            width: 100%;
            background: rgba(159, 168, 181, 0.2);
            height: 36px;
            line-height: 36px;
            margin-bottom: 10px;
            text-align: center;
            cursor: pointer;
            border: none;
            border-radius: 3px;
        }
        .bjy-item.active {
            background: #1e5eff;
            color: #fff;
        }
    }
    .bjy-device-settings {
        min-height: 420px;
        height: auto;
    }
    .bjy-device-settings-body {
        padding: 28px 28px 0;
        width: 450px;
        border-left: 1px solid #ccc;
        height: auto;
        .bjy-camera-setting {
            .bjy-camera-preview {
                width: 420px;
                height: 240px;
            }
            .bjy-camera-body {
                width: 100%;
                margin-left: 0;
            }
            .bjy-player-object {
                display: block;
                margin: 0 auto;
            }
        }
        .bjy-mic-setting {
            
        }
        .bjy-set-quality {
            display: none;
        }
    }
}
</style>
